import { useMutation } from "react-query";
import { editSingleHvac } from "../../../../actions/CarrierAgreementMgmt/Security";

const useEditSingleHvac = () => {
  return useMutation(editSingleHvac);
};
export default useEditSingleHvac;
